document.addEventListener("DOMContentLoaded", function () {
    const sectionsAgendaBlocks = document.querySelectorAll('.section-agenda-block'); // Wybieramy wszystkie sekcje na stronie

    sectionsAgendaBlocks.forEach(function (sectionAgendaBlock) {
        const showAgendaItems = sectionAgendaBlock.getAttribute('data-show-agenda-items');
        const defaultOpen = sectionAgendaBlock.getAttribute('data-default-open');

        const agendaItemsContainer = sectionAgendaBlock.querySelector('.section-agenda-block__items');
        const toggleButton = sectionAgendaBlock.querySelector('.js-toggle-agenda-items');
        const toggleIcon = sectionAgendaBlock.querySelector('.section-agenda-block__toggle-icon');

        // Początkowe ustawienie widoczności sekcji
        if (showAgendaItems === 'show') {
            agendaItemsContainer.style.display = 'block';
        } else {
            agendaItemsContainer.style.display = 'none';
        }

        if (defaultOpen === 'yes') {
            agendaItemsContainer.style.display = 'block';
            const expandText = document.createElement('span');
            expandText.textContent = 'Rozwiń';
            if (toggleButton) {
                toggleIcon.style.transform = 'rotate(0deg)';
                toggleButton.insertBefore(expandText, toggleIcon);
                expandText.style.display = 'none';
                toggleButton.addEventListener('click', function () {
                    if (agendaItemsContainer.style.display === 'none' || agendaItemsContainer.style.display === '') {
                        agendaItemsContainer.style.display = 'block';
                        toggleIcon.style.transform = 'rotate(0deg)';
                        expandText.style.display = 'none';
                    } else {
                        agendaItemsContainer.style.display = 'none';
                        toggleIcon.style.transform = 'rotate(180deg)';
                        expandText.style.display = 'block';
                    }
                });
            }
        } else {
            agendaItemsContainer.style.display = 'none';
            if (toggleButton) {
                toggleIcon.style.transform = 'rotate(180deg)';
                const expandText = document.createElement('span');
                expandText.textContent = 'Rozwiń';
                toggleButton.insertBefore(expandText, toggleIcon);
                toggleButton.addEventListener('click', function () {
                    if (agendaItemsContainer.style.display === 'none' || agendaItemsContainer.style.display === '') {
                        agendaItemsContainer.style.display = 'block';
                        toggleIcon.style.transform = 'rotate(0deg)';
                        expandText.style.display = 'none';
                    } else {
                        agendaItemsContainer.style.display = 'none';
                        toggleIcon.style.transform = 'rotate(180deg)';
                        expandText.style.display = 'block';
                    }
                });
            }
        }

        // Funkcja, która przenosi obrazek pod tytuł tematu na urządzeniach mobilnych
        const moveImageOnMobile = () => {
            const agendaItems = sectionAgendaBlock.querySelectorAll('.section-agenda-block__item');

            agendaItems.forEach(item => {
                const imageElement = item.querySelector('.js-section-agenda-block__image');
                const topicTitleElement = item.querySelector('.js-section-agenda-block__topic-title');
                const originalColumn = item.querySelector('.col-lg-3');

                if (!imageElement || !topicTitleElement || !originalColumn) return;

                if (window.innerWidth <= 768) {
                    if (!topicTitleElement.parentNode.contains(imageElement)) {
                        topicTitleElement.parentNode.insertBefore(imageElement, topicTitleElement.nextSibling);
                    }
                } else {
                    if (originalColumn && !originalColumn.contains(imageElement)) {
                        originalColumn.appendChild(imageElement);
                    }
                }
            });
        };

        moveImageOnMobile();
        window.addEventListener('resize', moveImageOnMobile);

// Function to add the "zobacz więcej" (Read More) button when the description is longer than 150 characters
        const agendaItems = sectionAgendaBlock.querySelectorAll('.section-agenda-block__item');

        agendaItems.forEach(item => {
            const descriptionElement = item.querySelector('.section-agenda-block__description-content');
            const readMoreButton = item.querySelector('.section-agenda-block__read-more-link');

            if (descriptionElement && descriptionElement.innerText.length > 150) {
                // Store the original content and truncated content
                const originalText = descriptionElement.innerHTML;

                // Remove &nbsp; (non-breaking spaces) and replace with a regular space
                const cleanedText = originalText.replace(/&nbsp;/g, ' ');

                // Truncate the cleaned text initially
                const truncatedText = cleanedText.slice(0, 150) + '...';

                // Set the truncated text in the description
                descriptionElement.innerHTML = truncatedText;

                // Show the "Zobacz więcej" button
                readMoreButton.style.display = 'inline-block';

                let expanded = false;

                // Handle the button click to toggle between showing the full text and truncated text
                readMoreButton.addEventListener('click', function () {
                    if (expanded) {
                        descriptionElement.innerHTML = truncatedText;
                        readMoreButton.textContent = 'zobacz więcej';
                        expanded = false;
                    } else {
                        descriptionElement.innerHTML = originalText;
                        readMoreButton.textContent = 'zobacz mniej';
                        expanded = true;
                    }
                });
            }
        });

    });
});